import { BrandThemeProvider } from '@montugroup/themes';
import { Button, Stack, TextField, Typography } from '@mui/material';
import type { FormEvent } from 'react';

import { AuthCardContainer, AuthPageContainer, Background, CentreContainer } from '@/components/auth/Styles';
import { usePortalPartnerBrand } from '@/hooks/portal-partner-brand';
import usePharmacistSetPassword from '@/hooks/usePharmacistSetPassword';
import { PasswordRequirements } from '@montugroup/circuit-shared/components/common/PasswordRequirements';
import { useParams } from 'react-router-dom';

function SetPassword() {
  const { onBoardKey } = useParams();
  const { key: brandName, Icon: Bg, Logo: TopLogo } = usePortalPartnerBrand();

  const { data, errors, handleUserInput, onRegister, isPending } = usePharmacistSetPassword(
    {
      email: '',
      password: '',
    },
    onBoardKey as string,
  );

  const handleRegister = async (e: FormEvent) => {
    e.preventDefault();
    await onRegister(data, e);
  };

  return (
    <BrandThemeProvider theme={brandName}>
      <AuthPageContainer>
        <CentreContainer>
          <AuthCardContainer>
            <Stack mb={10}>
              <TopLogo width="150px" height="auto" fillColor={(theme) => theme.palette.primary.main} />
            </Stack>
            <Stack gap={4}>
              <Typography sx={(theme) => ({ color: theme.palette.primary.main })} variant="h5" align="left">
                Pharmacist set password
              </Typography>
              <Typography textAlign={'left'}>
                Please enter your password below. Your password must:
                <PasswordRequirements isFirstPassword />
              </Typography>
              <form onSubmit={handleRegister}>
                <TextField
                  label="Email"
                  name="email"
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  error={!!errors.email}
                  helperText={errors.email}
                  value={data.email}
                  autoComplete="email"
                  sx={{
                    marginBottom: 0,
                  }}
                  disabled
                />
                <TextField
                  label="Password"
                  type="password"
                  name="password"
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  error={!!errors.password}
                  helperText={errors.password}
                  onChange={handleUserInput('text')}
                  value={data.password}
                  autoComplete="off"
                />
                <TextField
                  label="Confirm Password"
                  type="password"
                  name="rePassword"
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  error={!!errors.rePassword}
                  helperText={errors.rePassword}
                  onChange={handleUserInput('text')}
                  value={data.rePassword}
                  autoComplete="off"
                />
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    marginTop: 2,
                  }}
                  color="secondary"
                  disabled={isPending}
                  size="large"
                >
                  Set Password
                </Button>
              </form>
            </Stack>
          </AuthCardContainer>
        </CentreContainer>
      </AuthPageContainer>
      <Background>
        <Bg />
      </Background>
    </BrandThemeProvider>
  );
}

export default SetPassword;
